import axios from 'axios'

/**
 * 本地数据存储
 * @param {string} key
 * @param {any} value
 */
export const setLocalItem = (key: string, value: any) => {
    try {
        localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
        localStorage.setItem(key, value)
    }
}
/** 读取本地数据 */
export const getLocalItem = (key: string) => {
    try {
        return JSON.parse(localStorage.getItem(key) as string)
    } catch (error) {
        return localStorage.getItem(key)
    }
}

/**
 * 验证手机号码
 * @param {string} phoneNum
 */
export const isPhoneNumber = (phoneNum: string) => {
    if (!/^1[3456789]\d{9}$/.test(phoneNum)) {
        return false
    }
    return true
}

/**
 * 验证密码
 * @param {string} password
 * 至少包含数字和字母 6-16位
 */
export const isPsw = (password: string) => {
    // eslint-disable-next-line
    return /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z\d`~!@#$%^&*()_+<>?:"{},.\/;'[\]·！#￥（——）：；“”‘、，|《。》？、【】[\]]{6,16}$/.test(
        password
    )
}

/**
 * 判断是不是微信浏览器
 */
export function isWeixinBrowser() {
    const ua = navigator.userAgent.toLowerCase()
    return /micromessenger/.test(ua) && !/wxwork/.test(ua)
}

/** 节流函数 */
export const throttle = (
    fn: Function,
    delay: number = 500
): ((args: any) => void) => {
    var prev = Date.now()
    return function () {
        var args = arguments
        var now = Date.now()
        if (now - prev >= delay) {
            fn(args)
            prev = Date.now()
        }
    }
}
/** 防抖函数 */
export const debounce = (fn: Function, wait: number): Function => {
    let timer: number = -1
    return () => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            fn()
        }, wait) as any
    }
}

export const wxWebHookSenMsg = (msg: string) => {
    const hookUrl =
        'https://qyapi.weixin.qq.com/cgi-bin/webhook/send?key=46b60909-187f-4fdc-a831-10aec5540c02'
    const postBody = {
        msgtype: 'text',
        text: {
            content: msg,
            mentioned_list: ['JinchaoLee'],
        },
    }
    axios.post(hookUrl, postBody, {
        headers: {
            'content-type': 'application/json',
        },
    })
}
export const isAndroid = () => {
    let u = navigator.userAgent
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android终端或者uc浏览器
    return isAndroid === true
}

export const isIOS = () => {
    var u = navigator.userAgent
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    return isiOS
}
// 时间转换 Date=> string
export const formatDate = (date, modeType) => {
    /* eslint no-confusing-arrow: 0 */
    const pad = (n) => (n < 10 ? `0${n}` : n)
    if (modeType === 'datetime') {
        const dateStr = `${date.getFullYear()}-${pad(
            date.getMonth() + 1
        )}-${pad(date.getDate())}`
        const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`
        return `${dateStr} ${timeStr}`
    } else if (modeType === 'time') {
        const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`
        return `${timeStr}`
    }
}
// 兼容ios的parse
export const parserDate = function (date) {
    let t = date.replace(/-/g, '/')
    t = Date.parse(t)
    if (!isNaN(t)) {
        return new Date(t)
    } else {
        return new Date()
    }
}
